import { createSelector } from 'reselect';

import {
  // Utils
  localizedLink,
  // Frame
  hasUserSelector,
  localeSelector,
  newWorkFooterSelector,
  careersFooterSelector,
  investorRelationsFooterSelector,
  pressFooterSelector,
  newWorkExperienceFooterSelector,
} from '@xingternal/platform-layout-selectors';

const companyLinksSelector = createSelector(
  hasUserSelector,
  localeSelector,
  newWorkFooterSelector,
  careersFooterSelector,
  investorRelationsFooterSelector,
  pressFooterSelector,
  newWorkExperienceFooterSelector,
  (
    hasUser,
    locale,
    newWorkFooter,
    careersFooter,
    investorRelationsFooter,
    pressFooter,
    newWorkExperienceFooter
  ) => {
    const isDeutsch = locale === 'de';

    return [
      newWorkFooter,
      careersFooter,
      investorRelationsFooter,
      pressFooter,
      !hasUser && isDeutsch && newWorkExperienceFooter,
    ]
      .filter(Boolean)
      .map(localizedLink(locale));
  }
);

export { companyLinksSelector };
